import { observable, action, computed } from 'mobx';
import { handleMessages } from '../util';

// Checkout Store
export default class CheckoutStore {
  @observable calculation = new Map();
  @observable orderable = null;
  @observable isOrderAvailable = null;
  @observable isOfferAvailable = null;
  @observable editing = document.querySelectorAll('[data-checkout-update-form]').length > 0;
  @observable termsAccepted = document.querySelector('#id_accept_terms') === null ? true : null;
  @observable html = '';

  @computed get notOrderable() {
    return this.orderable === null ? null : !this.orderable;
  }

  @computed get isOrderNotAvailable() {
    if (this.editing || !this.termsAccepted) {
      return true;
    }
    if (this.isOrderAvailable === null) {
      return null;
    }
    if (!this.orderable) {
      return true;
    }
    return !this.isOrderAvailable;
  }

  @computed get isOfferNotAvailable() {
    if (this.editing || !this.termsAccepted) {
      return true;
    }
    if (this.isOfferAvailable === null) {
      return null;
    }
    if (!this.orderable) {
      return true;
    }
    return !this.isOfferAvailable;
  }

  @action
  setTermsAccepted(accepted) {
    this.termsAccepted = accepted;
  }

  @action
  load(url, data) {
    return $.ajax({
      url,
      data,
      method: data ? 'POST' : 'GET',
      processData: false,
      contentType: false,
      enctype: 'multipart/form-data',
    }).then(handleMessages).then((result) => {
      if (result.calculation) {
        this.calculation.replace(result.calculation);
        this.orderable = result.calculation.orderable;
        this.isOrderAvailable = result.calculation.is_order_available;
        this.isOfferAvailable = result.calculation.is_offer_available;
      }
      const messages = $('[data-checkout-confirm-messages]');
      if (messages.length) {
        messages.foundation('close');
        messages.remove();
      }
      this.html = result.html;
      this.editing = result.current_form !== 'main';
      this.termsAccepted = document.querySelector('#id_accept_terms') === null ? true : null;

      if (result.tracking_event_data) {
        if (window.gtag && result.tracking_event_data.analytics) {
          if (result.tracking_event_data.analytics.event && result.tracking_event_data.analytics.data) {
            window.gtag(
              'event',
              result.tracking_event_data.analytics.event,
              result.tracking_event_data.analytics.data,
            );
          }
        }
      }
    });
  }
}
